import styled from "styled-components";

export const Background = styled.div`
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  left: 0;
  top: 0;
  text-align: center;
`;

export const StyledConfirmModal = styled.div`
  background-color: #fff;
  border-radius: 10px;

  & h2 {
    margin-top: 32px;
    margin-bottom: 8px;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    /* text-align: center; */
  }

  & .notice {
    font-size: 14px;
    margin-left: 41px;
    margin-right: 42px;
    white-space: pre-line;
  }

  & .button {
    margin: 16px 16px 28px;

    & button {
      font-weight: 700;
      font-size: 14px;
      line-height: 20px;
      padding: 10px 45px;
      border-radius: 4px;

      border: none;
      outline: none;

      &:first-child {
        background-color: #f1f3f5;
        color: #878e95;
        margin-right: 8px;
        cursor: pointer;
      }

      &:last-child {
        background-color: #ff7a00;
        color: #fff;
        cursor: pointer;
      }
    }
  }
`;

export const StyledAfterConfirmModal = styled.div`
  background-color: #fff;
  font-size: 16px;
  font-weight: 700;
  border-radius: 8px;
  text-align: center;

  padding: 28px 63px;
`;

export const StyledAccused = styled.div`
  background-color: #fff;
  border-radius: 8px;

  & h2 {
    font-size: 16px;
    font-weight: 700;
    text-align: center;

    margin-top: 28px;
    margin-bottom: 8px;
  }

  & p {
    font-size: 14px;
    line-height: 20px;
    text-align: center;

    margin-right: 27px;
    margin-left: 27px;
    margin-bottom: 28px;
  }
`;
